var _path, _path2, _mask, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSidebarLeftBorderActive = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 48,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M12 .5C5.649.5.5 5.649.5 12v24c0 6.351 5.149 11.5 11.5 11.5Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#sidebar_left_border_active_svg__a)",
  d: "M12 .5C5.649.5.5 5.649.5 12v24c0 6.351 5.149 11.5 11.5 11.5Z"
})), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "sidebar_left_border_active_svg__c",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 12C0 5.373 5.373 0 12 0v48C5.373 48 0 42.627 0 36z"
}))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#sidebar_left_border_active_svg__b)",
  d: "M12 0C7.582 0 4 5.373 4 12v24c0 6.627 3.582 12 8 12-8.837 0-16-7.163-16-16V16C-4 7.163 3.163 0 12 0",
  mask: "url(#sidebar_left_border_active_svg__c)"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "sidebar_left_border_active_svg__a",
  x1: 6,
  x2: 6,
  y1: 48,
  y2: 0,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#04020D",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#04020D",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "sidebar_left_border_active_svg__b",
  x1: 0,
  x2: 12,
  y1: 48,
  y2: 14.913,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4048E4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9363F7"
})))));
export default SvgSidebarLeftBorderActive;